/* eslint-disable */
// Importa las funciones que necesitas del SDK de Firebase
import { initializeApp } from 'firebase/app'
import { getAnalytics } from 'firebase/analytics'
import { getAuth } from 'firebase/auth'

// Configuración para desarrollo
const firebaseConfigDevelopment = {
  apiKey: "AIzaSyBWyB_2yfCB-i71p29UR2BODFM_GLQAyG0",
  authDomain: "gcp-dev-465219.firebaseapp.com",
  projectId: "gcp-dev-465219",
  storageBucket: "gcp-dev-465219.firebasestorage.app",
  messagingSenderId: "931512667016",
  appId: "1:931512667016:web:7588f42e28e4d210ca083d",
  measurementId: "G-QT2GRE37R3"
}

// Configuración para beta

const firebaseConfigBeta = {
  apiKey: "AIzaSyCU2TM-pWIy-Gr09yB3rK6eg5oYjKEGF7Q",
  authDomain: "gcp-beta-503317.firebaseapp.com",
  projectId: "gcp-beta-503317",
  storageBucket: "gcp-beta-503317.firebasestorage.app",
  messagingSenderId: "824588280794",
  appId: "1:824588280794:web:f03cee1ae9a30d97bdd6e3"
};

// Configuración para producción
const firebaseConfigProduction = {
  apiKey: "AIzaSyA2knNr5nm1l2A_P1CT-dVgNkIyPfKdFi4",
  authDomain: "gcp-prod-465219.firebaseapp.com",
  projectId: "gcp-prod-465219",
  storageBucket: "gcp-prod-465219.firebasestorage.app",
  messagingSenderId: "199431199370",
  appId: "1:199431199370:web:b27734cbb882a5d3bdab73"
}

// Mapeo de configuraciones por entorno
const configs = {
  development: firebaseConfigDevelopment,
  beta: firebaseConfigBeta,
  production: firebaseConfigProduction
}

// Detecta el entorno (por defecto 'development')
const env = process.env.REACT_APP_ENVIRONMENT || 'development'

// Elige la config adecuada
//const firebaseConfig = configs[env]

// Determine the environment and choose the appropriate configuration
const firebaseConfig =
  env === 'production'
    ? firebaseConfigProduction
    : env === 'beta'
      ? firebaseConfigBeta
      : firebaseConfigDevelopment

if (process.env.NODE_ENV !== 'production') {
  console.info('[Auth][config]', {
    appEnvironment: env,
    nodeEnvironment: process.env.NODE_ENV,
    frontendOrigin: typeof window !== 'undefined' ? window.location.origin : 'unknown',
    backendBaseUrl: process.env.REACT_APP_BASE_URL,
    firebaseProjectId: firebaseConfig.projectId,
    firebaseAuthDomain: firebaseConfig.authDomain
  })
}

if (process.env.NODE_ENV !== 'production') {
  console.info('[Auth][config]', {
    appEnvironment: env,
    nodeEnvironment: process.env.NODE_ENV,
    frontendOrigin: typeof window !== 'undefined' ? window.location.origin : 'unknown',
    backendBaseUrl: process.env.REACT_APP_BASE_URL,
    firebaseProjectId: firebaseConfig.projectId,
    firebaseAuthDomain: firebaseConfig.authDomain
  })
}

// Inicializa Firebase
const app = initializeApp(firebaseConfig)
export const analytics = getAnalytics(app)
export const auth = getAuth(app)

export default app
